export const mutations = {
  SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_STRATEGY(state, strategy) {
    state.strategy = strategy;
  },
  SET_USER(state, user) {
    state.user = user;
  },
  SET_STATUS(state, status) {
    state.status = status;
  },
  BANNER_B_COOKIE(state, idPlan) {
    if (idPlan != 1) {
      this.$cookies.set('vx.hideBannerB', true);
    } else {
      this.$cookies.remove('vx.hideBannerB');
    }
  }
};

export const getters = {
  loggedIn: (state) => {
    return state.user && state.token;
  },
  token: (state) => {
    return state.token;
  },
  user: (state) => {
    return state.user;
  },
  strategy: (state) => {
    return state.strategy;
  }
};

export const actions = {
  async localLogin({ state, commit, dispatch }, data) {
    if (!state.user) {
      const { username, password, captchaToken } = data;
      if (!username || !password || !captchaToken) {
        return false;
      }
      try {
        commit('SET_STATUS', 'loading');
        const { status, data } = await this.$axios.post('auth/login/', {
          username,
          password,
          captchaToken
        });
        const token = data.accessToken;
        if (status === 200 && !data.error) {
          const domain = process.env.COOKIES_DOMAIN;
          const path = '/';

          commit('SET_STRATEGY', 'local');
          commit('SET_TOKEN', token);
          this.$cookies.set('vx.token.local', token, { domain, path });
          this.$cookies.set('vx.strategy', 'local', { domain, path });
          const { status, data } = await this.$axios.get('user/me/', {
            headers: { Authorization: token }
          });
          if (status === 200) {
            commit('SET_USER', data);
            commit('SET_STATUS', 'loaded');
            dispatch('PLAN_ID_COOKIE');
            commit('BANNER_B_COOKIE', data.idPlan);
            return true;
          }
        }
        commit('SET_STATUS', 'initial');
        return false;
      } catch (err) {
        commit('SET_STATUS', 'initial');
        const res = JSON.parse(err.request.response).message || 'invalid login';
        throw res;
      }
    }
  },
  async googleLogin({ state, commit, dispatch, rootGetters }, data) {
    if (!state.user) {
      const { id_token } = data;
      if (!id_token) {
        return false;
      }
      try {
        commit('SET_STATUS', 'loading');
        const { status, data } = await this.$axios.post('auth/login/google/', {
          id_token
        });
        const token = data.accessToken;
        if (status === 200 && !data.error) {
          const domain = process.env.COOKIES_DOMAIN;
          const path = '/';

          commit('SET_STRATEGY', 'google');
          commit('SET_TOKEN', token);
          this.$cookies.set('vx.token.google', token, { domain, path });
          this.$cookies.set('vx.strategy', 'google', { domain, path });
          const { status, data } = await this.$axios.get('user/me/', {
            headers: { Authorization: token }
          });
          if (status === 200) {
            commit('SET_USER', data);
            commit('SET_STATUS', 'loaded');
            dispatch('PLAN_ID_COOKIE');
            commit('BANNER_B_COOKIE', data.idPlan);
            if (rootGetters['vectors/purchaseFlowStatus'] === 'account') {
              dispatch('vectors/CHANGE_PURCHASE_FLOW_STATUS', 'payment', { root: true });
            }

            return true;
          }
        }
        commit('SET_STATUS', 'initial');
        return false;
      } catch (err) {
        console.error('Auth | googleLogin:', err);
        commit('SET_STATUS', 'initial');
        return false;
      }
    }
  },
  async facebookLogin({ state, commit, dispatch, rootGetters }, data) {
    if (!state.user) {
      const { accessToken } = data;
      if (!accessToken) {
        return false;
      }
      try {
        commit('SET_STATUS', 'loading');
        const { status, data } = await this.$axios.post('auth/login/facebook/', {
          accessToken
        });
        const token = data.accessToken;
        if (status === 200 && !data.error) {
          const domain = process.env.COOKIES_DOMAIN;
          const path = '/';

          commit('SET_STRATEGY', 'facebook');
          commit('SET_TOKEN', token);
          this.$cookies.set('vx.token.facebook', token, { domain, path });
          this.$cookies.set('vx.strategy', 'facebook', { domain, path });
          const { status, data } = await this.$axios.get('user/me/', {
            headers: { Authorization: token }
          });
          if (status === 200) {
            commit('SET_USER', data);
            commit('SET_STATUS', 'loaded');
            dispatch('PLAN_ID_COOKIE');
            commit('BANNER_B_COOKIE', data.idPlan);
            if (rootGetters['vectors/purchaseFlowStatus'] === 'account') {
              dispatch('vectors/CHANGE_PURCHASE_FLOW_STATUS', 'payment', { root: true });
            }

            return true;
          }
        }
        commit('SET_STATUS', 'initial');
        return false;
      } catch (err) {
        console.error('Auth | facebookLogin:', err);
        commit('SET_STATUS', 'initial');
        return false;
      }
    }
  },
  async loadUser({ state, commit, dispatch }, data) {
    const token = data.token;
    const strategy = data.strategy;
    const forceLoad = data.forceLoad ? data.forceLoad : false;
    const domain = process.env.COOKIES_DOMAIN;
    const path = '/';

    commit('SET_STRATEGY', strategy);
    commit('SET_TOKEN', token);
    this.$cookies.set(`vx.token.${strategy}`, token, { domain, path });
    this.$cookies.set('vx.strategy', strategy, { domain, path });
    if (!state.user || forceLoad) {
      commit('SET_STATUS', 'loading');
      try {
        const { status, data } = await this.$axios.get('user/me/', {
          headers: {
            Authorization: token
          }
        });
        if (status === 200) {
          commit('SET_USER', data);
          commit('SET_STATUS', 'loaded');
          this.$updateUserInfoIntercom();
          dispatch('PLAN_ID_COOKIE');
          commit('BANNER_B_COOKIE', data.idPlan);
        } else {
          commit('SET_STATUS', 'initial');
          return false;
        }
      } catch (err) {
        commit('SET_STATUS', 'initial');
        console.error('Auth | loadUser:', err);
      }
    }
  },
  logout({ state, commit, dispatch }) {
    const domain = process.env.COOKIES_DOMAIN;
    const path = '/';
    let strategy = this.$cookies.get('vx.strategy');

    if (strategy === '' || !strategy) {
      strategy = state.strategy;
    }
    this.$cookies.remove('vx.strategy', { domain, path });
    this.$cookies.remove(`vx.token.${strategy}`, { domain, path });
    dispatch('REMOVE_PLAN_ID_COOKIE');
    commit('SET_TOKEN', false);
    commit('SET_STRATEGY', false);
    commit('SET_USER', false);
    this.$rebootIntercom();
  },
  PLAN_ID_COOKIE({ state, rootGetters }) {
    const domain = process.env.COOKIES_DOMAIN;
    const path = '/';

    const merch = rootGetters['experience/getMerch'];
    const design = rootGetters['experience/getDesign'];
    const userPlanType = this.$auth.user.userPlanType;
    if (userPlanType == merch) {
      this.$cookies.set('vx.plan_merch', 'plan_merch', { domain, path });
    } else if (userPlanType == design) {
      this.$cookies.set('vx.plan_design', 'plan_design', { domain, path });
    }

    let planId = parseInt(state.user.idPlan);
    let nameSetted = '';

    if (planId) {
      nameSetted = 'u_p_i' + planId;
      this.$cookies.set(nameSetted, '1', { domain, path });
    }
    for (let i = 0; i < 100; i++) {
      let name = 'u_p_i' + i;
      if (name != nameSetted) {
        this.$cookies.remove(name);
      }
    }
  },
  REMOVE_PLAN_ID_COOKIE() {
    const domain = process.env.COOKIES_DOMAIN;
    const path = '/';
    this.$cookies.remove('vx.plan_merch', { domain, path });
    this.$cookies.remove('vx.plan_design', { domain, path });
  }
};

export const state = () => ({
  user: false,
  token: false,
  strategy: false,
  status: 'initial'
});
